import { useAuth } from "@/app/providers/AuthContext"; // Adjust path if needed
import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProperties {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProperties> = ({
  children,
}) => {
  const { session, isReady } = useAuth();
  const location = useLocation();

  const navigationState = useMemo(() => ({ from: location }), [location]);

  // Check if we're on the periochart subdomain - if so, bypass all auth checks
  const shouldBypassAuth = useMemo(() => {
    if (typeof window === "undefined") return false;
    const hostname = window.location.hostname;
    const bypassPrefixes = ["periochart", "treatments"];
    return bypassPrefixes.some(
      (prefix) =>
        hostname === `${prefix}.zermmi.com` ||
        hostname.startsWith(`${prefix}.`)
    );
  }, []);

  if (shouldBypassAuth) {
    return <>{children}</>;
  }

  // While checking the session, don't render anything (or show a loader)
  if (!isReady) {
    return null; // Or return a loading spinner component
  }

  // If there's no session and loading is finished, redirect to login
  if (!session) {
    return <Navigate to="/login" replace state={navigationState} />;
  }

  // If session exists, render the children (the protected content, e.g., AppShell)
  return <>{children}</>;
};
